
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import moment, { Moment } from 'moment';
    import { Situacion } from '@/__env/lib/Pantalla/Situacion';
    import { Empresa, Cuenta } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    import { Cliente, EstadisticaVentas } from '@/__env/lib/Clientes';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Fecha: Moment = moment();
        public Cuentas: Cuenta[] = [Cuenta.CASAJARSE, Cuenta.JARSEINDUSTRIALCOMERCIALSA];

        async mounted()
        {
            this.buscar();
        }

        public Items: EstadisticaVentas[] = [];
        async buscar()
        {
            this.Items.clear();
            for ( let emp of this.Cuentas )
            {
                this.Items.push( await EstadisticaVentas.create( emp.Cliente, moment().getMonth(), moment().getYear() ));
            }

        }
    }
